
import { Certification } from "../data/certifications";

export const sortCertifications = (certifications: Certification[]): Certification[] => {
  return [...certifications].sort((a, b) => {
    // First sort by featured status (featured items come first)
    if (a.featured && !b.featured) return -1;
    if (!a.featured && b.featured) return 1;
    
    // Then sort by date (more recent dates come first)
    // Parse dates for comparison
    const dateA = a.date.includes(" ") 
      ? new Date(a.date) 
      : new Date(`Jan 1, ${a.date}`); // Handle year-only dates
    
    const dateB = b.date.includes(" ") 
      ? new Date(b.date) 
      : new Date(`Jan 1, ${b.date}`);
    
    return dateB.getTime() - dateA.getTime();
  });
};
